// Tekil taşınmaz bilgi notu PDF'i — detay kartıyla aynı bölümler + statik OSM haritası (jsPDF + autoTable, Türkçe font)
import { startReport, addHeading, addTable, addKpis, addParagraph, addImage, finishReport, stamp } from './reportPdf';
import { buildStaticMap } from './staticMap';
import { tesisTuruText } from './tesisTuru';
import {
  KONUM_KIND, turInfo, isYapiTuru, mulkiyetText, fmtAlan, konumMetni, emlakBaslik, hasDepremYangin,
  temelSatirlari, konumSatirlari, mulkiyetSatirlari, kamulastirmaSatirlari, depremYanginSatirlari, kayitSatirlari,
} from '../components/modules/emlak/emlakOrtak';

const GRAY = [107, 114, 128];
const DARK = [31, 41, 55];
const COLS = { 0: { textColor: GRAY, cellWidth: 42 }, 1: { cellWidth: 51 }, 2: { textColor: GRAY, cellWidth: 42 }, 3: { cellWidth: 51 } };
const safeName = (s) => String(s || '').replace(/[^0-9A-Za-zÇĞİÖŞÜçğıöşü_-]+/g, '-').slice(0, 40);

// [etiket, değer, stil] satırlarını 2 sütunlu Alan/Değer tablosuna çevirir; stil.pdf hücre dolgusu olur
function section(ctx, title, rows) {
  const body = []; const fills = {};
  for (let i = 0; i < rows.length; i += 2) {
    const a = rows[i]; const b = rows[i + 1];
    body.push([a[0], a[1] || '-', b?.[0] || '', b ? (b[1] || '-') : '']);
    if (a[2]?.pdf && a[1]) fills[`${body.length - 1}:1`] = a[2].pdf;
    if (b?.[2]?.pdf && b[1]) fills[`${body.length - 1}:3`] = b[2].pdf;
  }
  addHeading(ctx, title, 1);
  addTable(ctx, ['Alan', 'Değer', 'Alan', 'Değer'], body, {
    fontSize: 8,
    columnStyles: COLS,
    cellStyler: (r, c) => (fills[`${r}:${c}`] ? { fillColor: fills[`${r}:${c}`], textColor: DARK } : null),
  });
}

export async function exportEmlakDetayPDF(e, { geo } = {}) {
  const baslik = emlakBaslik(e);
  const tur = turInfo(e.tasinmaz_turu);
  const ctx = startReport({
    title: `Taşınmaz Bilgi Notu — ${baslik}`,
    subtitle: `${[e.il || 'İstanbul', e.ilce, e.mahalle].filter(Boolean).join(' / ')} — ${tur.label}`,
    orientation: 'portrait', meta: 'Emlak-Kamulaştırma Modülü',
  });
  addKpis(ctx, [
    { label: 'Taşınmaz Türü', value: tur.label },
    { label: 'Tesis Türü', value: tesisTuruText(e.tesis_turu) || '-' },
    { label: isYapiTuru(e.tasinmaz_turu) ? 'İnşaat Alanı' : 'Alan', value: fmtAlan(isYapiTuru(e.tasinmaz_turu) ? e.insaat_alani_m2 : e.alan_m2) || '-', sub: isYapiTuru(e.tasinmaz_turu) && fmtAlan(e.alan_m2) ? `Arsa: ${fmtAlan(e.alan_m2)}` : '' },
    { label: 'Mülkiyet', value: mulkiyetText(e) || '-' },
  ]);

  let no = 1;
  section(ctx, `${no++}. Taşınmaz Türü ve Tesis Bilgileri`, temelSatirlari(e));
  section(ctx, `${no++}. Konum ve Kadastro`, konumSatirlari(e));
  if (geo) {
    const kind = KONUM_KIND[geo.kind] || KONUM_KIND.ilce;
    const map = await buildStaticMap({ lat: geo.lat, lon: geo.lon, zoom: kind.zoom });
    const link = `https://www.google.com/maps?q=${geo.lat},${geo.lon}`;
    if (map.ok) {
      addImage(ctx, map.dataUrl, { height: (ctx.w - 2 * ctx.m) * 0.46, caption: `${konumMetni(e)} · ${kind.text} · ${geo.lat.toFixed(6)}, ${geo.lon.toFixed(6)} — Google Maps'te aç »`, link });
    } else {
      addParagraph(ctx, `Harita görüntüsü alınamadı. Konum: ${geo.lat.toFixed(6)}, ${geo.lon.toFixed(6)} (${kind.text}) — ${link}`, { color: GRAY });
    }
  }
  section(ctx, `${no++}. Mülkiyet ve Tahsis Bilgileri`, mulkiyetSatirlari(e));
  const kamu = kamulastirmaSatirlari(e);
  if (kamu.length) {
    addHeading(ctx, 'Kamulaştırma Bilgileri', 2);
    addTable(ctx, ['Alan', 'Değer', 'Alan', 'Değer'], [[kamu[0][0], kamu[0][1] || '-', kamu[1][0], kamu[1][1] || '-'], [kamu[2][0], kamu[2][1] || '-', kamu[3][0], kamu[3][1] || '-'], [kamu[4][0], kamu[4][1] || '-', '', '']], {
      fontSize: 8, headerColor: [180, 83, 9], columnStyles: COLS,
    });
  }
  if (hasDepremYangin(e)) section(ctx, `${no++}. Deprem, Güçlendirme ve Yangın Yönetmeliği`, depremYanginSatirlari(e));
  addHeading(ctx, `${no++}. Açıklama ve Kayıt Bilgileri`, 1);
  addParagraph(ctx, e.aciklama || 'Açıklama girilmemiş.', { color: e.aciklama ? DARK : GRAY });
  addTable(ctx, ['Alan', 'Değer', 'Alan', 'Değer'], (() => { const k = kayitSatirlari(e); return [[k[0][0], k[0][1] || '-', k[1][0], k[1][1] || '-'], [k[2][0], k[2][1] || '-', k[3][0], k[3][1] || '-']]; })(), {
    fontSize: 7.5, columnStyles: COLS,
  });
  finishReport(ctx, `tasinmaz-bilgi-notu-${safeName(baslik)}-${stamp()}.pdf`);
}
